import { AppBar, Button, Chip, Dialog, Grid, IconButton, Slide, Toolbar, Typography } from '@mui/material';
import { forwardRef, useEffect, useState } from 'react';
import { ArrowRightAltRounded, Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { saveDraft, selectDesgination, selectDraft, selectEditPreview, setEditPreview } from '../../giftSlice';
import { ShowMore } from './ShowMore';
import { variants } from '../../../../variants/variants';
import toast from 'react-hot-toast';
import { useTheme } from '@emotion/react';
import { Stack } from '@mui/material';
import { empty } from '../../assets';
import { selectSwipeEdge } from '../../../Search/searchSlice';
const Transition = forwardRef(function Transition (props, ref) {
  return <Slide direction='left' ref={ref} {...props} />;
});
const EditPreview = () => {
  const open = useSelector(selectEditPreview);
  const dispatch = useDispatch();
  const completed = useSelector(selectDraft);
  const designations = useSelector(selectDesgination);
  const [show, setShow] = useState(1);
  const theme = useTheme();
  const swipeOpen = useSelector(selectSwipeEdge);
  const handleClose = () => {
    dispatch(setEditPreview({ value: false }));
  };
  const handleSave = () => {
    dispatch(saveDraft());
    toast.success('Saved successfully!');
  };
  const [disabled, setDisabled] = useState(false);
  const handleDisableChange = (val) => {
    setDisabled(val);
  };
  const handleClick = (val) => {
    setShow(val);
  };

  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: 'relative', background: '#fff', color: '#0A4FAC' }}>
        <Toolbar>
          <IconButton edge='start' {...(open && { className: 'backButton' })} onClick={handleClose}>
            <Close />
          </IconButton>
          <Typography
            sx={{
              fontSize: variants.SUB_HEAD,
              fontWeight: 700,
              ml: 1,
              [theme.breakpoints.down('lg')]: {
                fontSize: variants.BODY,
              },
            }}
          >
            Edit Application
          </Typography>
          <Button disabled={disabled} size='small' variant='contained' onClick={handleSave} sx={{ ml: 'auto' }}>
            save changes
          </Button>
        </Toolbar>
      </AppBar>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{
          m: 1,
          display: { xs: 'flex' },
          [theme.breakpoints.up('md')]: {
            display: 'none',
          },
        }}
      >
        <Chip
          label={designations.current.split(' - ')[0]}
          variant='outlined'
          onClick={() => handleClick(1)}
          sx={{
            background: show === 1 ? '#0A4FAC' : 'inherit',
            color: show === 1 ? 'white' : 'inherit',
          }}
        />
        <ArrowRightAltRounded fontSize='large' sx={{ color: '#0A4FAC' }} />
        <Chip
          label={designations.desired.split(' - ')[0]}
          variant='outlined'
          onClick={() => handleClick(2)}
          sx={{
            background: show === 2 ? '#0A4FAC' : 'inherit',
            color: show === 2 ? 'white' : 'inherit',
          }}
        />
      </Stack>
      <Grid container sx={{ height: '100%', overflowY: 'auto' }}>
        {/* Current designation kras */}
        <Grid
          item
          container
          xs={12}
          lg={6}
          sx={{
            [theme.breakpoints.down('lg')]: {
              display: show === 1 ? 'block' : 'none',
            },
            border: 0,
            height: 'fit-content',
            p: 1,
            justifyContent: 'center',
          }}
        >
          <Chip
            label={`Current Designation : ${designations?.current}`}
            sx={{
              mx: 1,
              background: '#EEF5FF',
              [theme.breakpoints.down('lg')]: {
                display: 'none',
              },
            }}
          />
          <Grid container>
            {completed.current &&
              Object.keys(completed.current).map((title, index1) => {
                let questions = completed['current'][title];
                return (
                  <Grid key={index1} item xs={12} sx={{ p: 1 }}>
                    <ShowMore
                      items={questions}
                      designation={'current'}
                      title={title}
                      sliceCount={3}
                      handleDisableChange={handleDisableChange}
                    />
                  </Grid>
                );
              })}
            {completed?.current && Object.keys(completed?.current)?.length === 0 && (
              <Stack alignItems={'center'} sx={{ p: 2, mt: 2, mx: 'auto' }}>
                <img style={{ width: '50%' }} src={empty} alt='pending' />
                <Typography sx={{ fontSize: variants.TINY, p: 1, color: 'rgba(0,0,0,0.7)' }}>
                  No preview available!
                </Typography>
              </Stack>
            )}
          </Grid>
        </Grid>
        {/* Desired designation */}
        <Grid
          item
          container
          xs={12}
          lg={6}
          sx={{
            [theme.breakpoints.down('lg')]: {
              display: show === 2 ? 'block' : 'none',
            },
            border: 0,
            height: 'fit-content',
            p: 1,
            justifyContent: 'center',
          }}
        >
          <Chip
            label={`Desired Designation : ${designations.desired}`}
            sx={{
              mx: 1,
              background: '#EEF5FF',
              [theme.breakpoints.down('lg')]: {
                display: 'none',
              },
            }}
          />
          <Grid container>
            {completed.desired &&
              Object.keys(completed.desired).map((title, index1) => {
                let questions = completed['desired'][title];
                return (
                  <Grid key={index1} item sx={{ p: 1 }}>
                    <ShowMore
                      items={questions}
                      designation={'desired'}
                      title={title}
                      sliceCount={3}
                      handleDisableChange={handleDisableChange}
                    />
                  </Grid>
                );
              })}
            {completed?.desired && Object.keys(completed?.desired)?.length === 0 && (
              <Stack alignItems={'center'} sx={{ p: 2, mt: 2, mx: 'auto' }}>
                <img style={{ width: '50%' }} src={empty} alt='pending' />
                <Typography sx={{ fontSize: variants.TINY, p: 1, color: 'rgba(0,0,0,0.7)' }}>
                  No preview available!
                </Typography>
              </Stack>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default EditPreview;
